import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'mx-auto grid max-w-346 gap-2 px-3 lg:grid-cols-2 lg:gap-5',
    card: 'bg-blue-light relative cursor-pointer px-4 py-6 lg:px-10 lg:pt-10 lg:pb-20',
    top: 'mb-5 flex items-center gap-6 lg:mb-6 lg:gap-8',
    photo:
      'text-blue max-h-24 min-h-24 max-w-24 min-w-24 overflow-hidden rounded-full border-[2px] border-white lg:-mt-2 lg:min-h-30 lg:min-w-30',
    photoIcon: 'max-h-24 max-w-24 lg:max-h-30 lg:max-w-30',
    info: '',
    labels: 'mt-5 flex flex-wrap gap-1 lg:mt-0 lg:mb-3',
    labelsDesktop: 'mb-3 hidden flex-wrap gap-1 lg:flex',
    labelsMobile: 'mt-5 flex flex-wrap gap-1 lg:hidden',
    label:
      'bg-blue flex-center text-bold flex h-6 rounded-[100px] px-2.5 text-[12px] leading-[1.2] tracking-[0.045em] text-white uppercase',
    name: 'heading-m-bold mb-1',
    subtitle: 'heading-s mb-3 line-clamp-3 lg:mb-4 lg:line-clamp-1',
    experience: 'heading-xs text-secondary-hover',
    desktopInfo: 'hidden lg:block',
    mobileInfo: 'block lg:hidden',
    bottom: 'pb-[2px]',
    city: 'mt-6 mb-3 lg:mb-4',
    addresses: 'grid gap-2',
    address:
      'heading-xs hover:text-blue flex items-start gap-2 transition-colors',
    addressIcon: 'text-[#BFD7F2]',
    button:
      'heading-xs-bold h-auto px-0 pt-5 pb-0 tracking-[0.06em] lg:absolute lg:bottom-10 lg:pt-0',
    buttonContent: 'flex items-center gap-2',
    pagination: 'flex items-center justify-center px-3 pt-10',
    empty: 'heading-xl px-4 text-center lg:px-10 lg:text-left'
  }
});
